import { MediaManagerFolderTreeNode } from '../models/media-manager/media-manager-file-system';

export class MediaManagerUtils {
  static BUD_SENSE_ADMIN_COMPANY_ID = -1;

  static folderCreationDepthLimitReached(folderDepth: number | null): boolean {
    return folderDepth !== null && folderDepth >= 2;
  }

  static getDestinationPathString(currentNode: MediaManagerFolderTreeNode): string {
    let path = 'Media';
    if (!currentNode || currentNode.id === 'ROOT') {
      return path;
    }
    const folderPath = currentNode.path || [];
    const pathIncludesCurrentFolder = folderPath.some(pathNode => pathNode?.id === currentNode.id);
    const leafFolderName = pathIncludesCurrentFolder ? folderPath[folderPath.length - 1]?.name : currentNode.name;
    if (!leafFolderName) {
      return path;
    }
    if (folderPath.length <= 1) {
      path += ` > ${leafFolderName}`;
    } else {
      path += ` > ... > ${leafFolderName}`;
    }
    return path;
  }
}
